import {
  fetch_backups,
  fetch_backup_tables,
  fetch_queue_health,
  create_backup,
  send_backup_link,
  cancel_backup,
  delete_backup,
} from "../../api/databaseBackups"

export const FETCH_BACKUPS_REQUEST = "FETCH_BACKUPS_REQUEST"
export const FETCH_BACKUPS_SUCCESS = "FETCH_BACKUPS_SUCCESS"
export const FETCH_BACKUPS_FAILURE = "FETCH_BACKUPS_FAILURE"
export const FETCH_BACKUP_TABLES_SUCCESS = "FETCH_BACKUP_TABLES_SUCCESS"
export const FETCH_QUEUE_HEALTH_SUCCESS = "FETCH_QUEUE_HEALTH_SUCCESS"

export const loadBackups = (perPage = 25, page = 1) => async (dispatch) => {
  dispatch({ type: FETCH_BACKUPS_REQUEST })
  try {
    const result = await fetch_backups(perPage, page)
    if (result && result.data) {
      dispatch({ type: FETCH_BACKUPS_SUCCESS, payload: result.data })
      return result.data
    }
    dispatch({ type: FETCH_BACKUPS_FAILURE })
    return null
  } catch (e) {
    dispatch({ type: FETCH_BACKUPS_FAILURE })
    return null
  }
}

export const loadBackupTables = () => async (dispatch) => {
  const result = await fetch_backup_tables()
  const tables = result?.tables || []
  dispatch({ type: FETCH_BACKUP_TABLES_SUCCESS, payload: tables })
  return tables
}

export const loadQueueHealth = () => async (dispatch) => {
  const result = await fetch_queue_health()
  if (result) {
    dispatch({ type: FETCH_QUEUE_HEALTH_SUCCESS, payload: result })
  }
  return result
}

export const createBackup = (payload) => async () => create_backup(payload)
export const sendBackupLink = (id) => async () => send_backup_link(id)
export const cancelBackup = (id) => async () => cancel_backup(id)
export const deleteBackup = (id) => async () => delete_backup(id)
